import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1280.000000 698.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,698.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M6370 6258 c-12 -24 -42 -79 -65 -123 -24 -44 -59 -109 -79 -143 -20
-35 -36 -73 -36 -83 0 -17 84 -186 117 -234 24 -35 16 -42 -62 -48 -88 -8
-133 -17 -277 -59 -59 -18 -110 -30 -112 -27 -6 5 -95 265 -103 298 l-6 24 32
-19 c18 -10 40 -26 49 -34 9 -8 50 -35 90 -59 40 -24 75 -47 78 -52 10 -17 29
-8 47 22 9 17 17 34 17 38 0 5 -48 39 -107 77 -60 38 -168 109 -242 157 -73
49 -135 87 -136 85 -3 -3 93 -291 150 -448 15 -41 35 -104 46 -139 10 -36 22
-68 27 -73 4 -4 48 8 97 28 149 58 310 86 516 90 175 4 178 4 313 -31 75 -20
142 -33 149 -29 7 4 9 3 4 -1 -8 -10 115 -66 124 -56 11 11 40 113 34 119 -3
4 -10 0 -15 -8 -9 -14 -50 -22 -50 -9 0 4 -9 5 -20 2 -11 -3 -20 -1 -20 4 0 5
-19 15 -42 22 -24 7 -56 19 -73 26 -37 17 -246 55 -297 55 -21 0 -38 4 -38 10
0 5 27 61 60 122 34 62 63 123 66 134 5 21 -46 137 -86 194 -9 14 -39 67 -65
118 -26 50 -51 92 -55 92 -3 0 -17 -19 -30 -42z m89 -102 c9 -10 9 -20 0 -40
-11 -24 -13 -24 -25 -8 -30 39 -6 85 25 48z m6 -138 c28 -56 49 -109 47 -117
-4 -19 -104 -221 -109 -221 -2 0 -16 26 -30 58 -15 31 -39 78 -55 103 -15 25
-28 53 -28 62 0 26 104 217 118 216 4 0 30 -46 57 -101z m85 -51 c0 -7 -9 -13
-20 -13 -11 0 -20 6 -20 13 0 7 9 13 20 13 11 0 20 -6 20 -13z m50 -55 c0 -6
-5 -14 -12 -18 -8 -5 -9 0 -5 15 4 17 3 20 -8 11 -15 -13 -28 11 -19 35 5 12
10 10 25 -9 10 -13 19 -29 19 -34z m-65 -112 c-3 -5 -10 -10 -16 -10 -5 0 -9
5 -9 10 0 6 7 10 16 10 8 0 12 -4 9 -10z m-85 -100 c0 -5 -2 -10 -4 -10 -3 0
-8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m271 -117 c-7 -3 -22 -14 -32
-24 -23 -23 -49 -25 -49 -4 0 8 5 15 11 15 5 0 7 -4 4 -10 -3 -5 -1 -10 4 -10
10 0 15 14 12 33 0 4 14 7 32 6 17 0 26 -3 18 -6z m38 -7 c-15 -13 -49 -25
-49 -17 0 5 8 12 18 14 24 6 36 8 31 3z m175 -87 c-3 -5 -10 -7 -15 -3 -5 3
-7 10 -3 15 3 5 10 7 15 3 5 -3 7 -10 3 -15z"
          />
          <path
            d="M5966 6014 c-16 -81 -16 -98 -5 -105 104 -70 105 -70 135 8 l16 42
-50 64 c-80 100 -76 100 -96 -9z"
          />
          <path
            d="M6784 6073 c-16 -21 -42 -52 -58 -70 -32 -37 -31 -75 2 -125 l18 -27
53 31 c44 26 52 34 47 53 -3 12 -10 55 -16 95 -6 41 -12 75 -13 77 -2 1 -17
-14 -33 -34z m9 -73 c3 -11 1 -20 -4 -20 -5 0 -9 9 -9 20 0 11 2 20 4 20 2 0
6 -9 9 -20z m24 -17 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z"
          />
          <path
            d="M7166 6035 c-21 -19 -43 -35 -49 -35 -6 0 -42 -21 -81 -46 -133 -88
-231 -151 -258 -168 -33 -19 -35 -35 -10 -66 l18 -22 95 58 c124 76 153 100
133 108 -24 9 -31 7 -14 -4 9 -6 10 -10 3 -10 -20 0 -25 20 -6 27 10 4 21 10
24 15 3 5 25 2 49 -6 24 -8 47 -13 52 -10 14 9 9 -47 -6 -62 -13 -12 -16 -12
-24 2 -12 22 -39 12 -51 -18 -14 -33 -71 -213 -71 -221 0 -4 9 -2 20 5 13 8
19 20 16 32 -3 11 -1 15 4 10 4 -5 11 -18 14 -29 3 -11 4 -3 3 18 -2 20 1 37
5 37 9 0 12 -21 9 -65 l-2 -30 15 28 c14 26 166 466 166 481 0 14 -18 4 -54
-29z m11 -55 c-6 -22 -15 -40 -19 -40 -4 0 -7 3 -6 8 0 4 -3 16 -7 26 -6 13
-4 21 3 24 7 2 10 8 6 13 -3 5 3 9 14 9 18 0 18 -4 9 -40z m-292 -211 c-8 -12
-35 -12 -35 0 0 11 22 20 33 14 4 -2 5 -9 2 -14z m142 -91 c-3 -8 -6 -5 -6 6
-1 11 2 17 5 13 3 -3 4 -12 1 -19z"
          />
          <path
            d="M6955 5550 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path
            d="M6200 5429 c-25 -5 -77 -16 -116 -23 -105 -21 -266 -88 -382 -159
-112 -69 -282 -219 -356 -316 -81 -105 -174 -278 -206 -384 -59 -197 -74 -302
-67 -481 10 -284 93 -521 265 -755 l54 -73 49 6 c81 11 85 14 51 50 -50 52
-139 182 -181 265 -141 277 -170 642 -75 931 38 113 117 272 171 342 78 103
222 241 313 300 122 79 198 114 329 152 149 43 239 57 378 57 95 0 135 -5 260
-36 82 -19 158 -40 171 -45 14 -6 22 -6 22 0 0 6 -7 10 -15 10 -8 0 -15 3 -15
8 0 10 79 2 86 -9 11 -18 25 -9 19 13 -6 16 -4 20 9 15 8 -3 18 -3 20 2 8 12
-186 90 -262 106 -159 33 -418 45 -522 24z m359 -15 c2 -2 -14 -4 -37 -4 -23
0 -42 -4 -42 -10 0 -5 -4 -10 -9 -10 -7 0 -8 16 -2 38 1 3 85 -10 90 -14z
m-115 -9 c-4 -8 -10 -15 -14 -15 -4 0 -10 7 -14 15 -4 10 1 15 14 15 13 0 18
-5 14 -15z"
          />
          <path
            d="M7043 5266 c5 -11 0 -12 -24 -6 -31 9 -37 2 -17 -18 17 -17 -13 -16
-31 1 -11 10 -13 9 -8 -6 7 -20 -4 -16 -36 11 -21 18 -36 9 -15 -10 7 -7 44
-29 81 -47 37 -19 67 -38 67 -42 0 -4 8 -10 19 -14 10 -3 28 -13 39 -23 11 -9
49 -39 84 -66 35 -27 84 -77 111 -110 26 -34 62 -77 80 -96 38 -42 159 -282
181 -360 64 -229 60 -549 -10 -756 -47 -141 -147 -316 -239 -419 l-35 -40 42
-13 c76 -22 77 -21 198 158 27 41 50 83 50 92 0 9 4 19 9 22 15 9 20 45 6 40
-16 -7 -33 43 -26 75 6 21 8 22 20 7 7 -8 18 -13 23 -10 6 4 8 -6 4 -27 -5
-30 -3 -28 18 16 14 28 31 73 39 101 14 47 14 51 -1 50 -13 -1 -17 8 -17 42 0
23 -3 42 -7 42 -5 0 -8 4 -8 10 0 5 10 8 23 6 19 -3 22 -9 20 -47 -2 -44 -2
-43 19 21 29 89 32 391 5 520 -35 168 -146 428 -213 498 l-25 27 11 -25 c13
-30 -1 -80 -23 -80 -7 0 -21 14 -31 31 -15 26 -16 33 -5 40 8 5 19 9 26 9 18
0 21 33 4 60 -29 47 -66 87 -161 172 -92 82 -257 192 -247 164z m43 -41 c11
-11 8 -13 -21 -12 -19 1 -35 6 -35 12 0 16 40 16 56 0z m-71 -15 c3 -5 2 -10
-4 -10 -5 0 -13 5 -16 10 -3 6 -2 10 4 10 5 0 13 -4 16 -10z m305 -149 c13
-26 13 -31 -5 -31 -9 0 -12 -6 -9 -17 5 -17 4 -17 -9 0 -11 13 -16 15 -20 5
-2 -7 -8 -10 -12 -6 -4 4 0 17 9 29 15 22 14 25 -7 47 l-22 25 32 -17 c18 -9
37 -25 43 -35z m-95 -1 c3 -5 2 -10 -4 -10 -5 0 -13 5 -16 10 -3 6 -2 10 4 10
5 0 13 -4 16 -10z m349 -416 c5 -14 4 -15 -9 -4 -17 14 -19 20 -6 20 5 0 12
-7 15 -16z m41 -36 c4 -29 11 -55 16 -58 12 -8 -12 -80 -27 -80 -6 0 -14 9
-17 19 -6 26 3 71 15 71 11 0 6 49 -7 83 -4 9 -3 17 3 17 6 0 13 -24 17 -52z
m93 -473 c0 -44 -3 -70 -5 -57 -7 35 -23 26 -18 -10 4 -26 3 -29 -4 -13 l-10
20 -1 -20 c-1 -19 -1 -19 -12 -1 -14 24 -22 188 -8 166 7 -11 10 -11 10 -2 0
7 6 19 13 26 22 24 36 -21 35 -109z m-101 -337 c-3 -8 -6 -5 -6 6 -1 11 2 17
5 13 3 -3 4 -12 1 -19z m-85 -240 c-7 -7 -12 -8 -12 -2 0 14 12 26 19 19 2 -3
-1 -11 -7 -17z m-87 -211 c2 -34 0 -43 -9 -35 -6 6 -10 27 -9 47 2 46 2 45 9
39 3 -4 7 -26 9 -51z m35 33 c13 -8 11 -13 -9 -32 -23 -23 -23 -23 -12 -1 14
27 14 36 1 28 -5 -3 -10 -1 -10 4 0 13 10 14 30 1z"
          />
          <path d="M7687 4175 c3 -22 7 -42 9 -44 8 -9 2 45 -6 64 -7 14 -8 8 -3 -20z" />
          <path
            d="M6210 5241 c0 -5 14 -33 32 -60 34 -56 34 -55 -17 -138 l-26 -43 34
0 c28 0 36 5 50 35 9 19 20 35 25 35 5 0 16 -16 25 -35 14 -30 22 -35 52 -35
l34 0 -36 62 -36 62 29 55 c40 75 40 73 8 69 -19 -2 -35 -13 -49 -35 -11 -18
-22 -32 -25 -32 -3 -1 -15 15 -28 34 -15 25 -30 35 -47 35 -14 0 -25 -4 -25
-9z"
          />
          <path
            d="M6440 5125 l0 -125 28 0 27 0 -1 93 c-3 165 -1 157 -29 157 l-25 0 0
-125z"
          />
          <path
            d="M6540 5141 c0 -60 -3 -116 -6 -125 -5 -13 1 -16 25 -16 l31 0 0 125
0 125 -25 0 -25 0 0 -109z"
          />
          <path
            d="M5824 5092 l-22 -17 46 -82 c25 -46 48 -83 52 -83 3 0 15 6 26 14 19
14 18 16 -16 80 -19 37 -42 75 -50 86 -14 18 -16 18 -36 2z"
          />
          <path
            d="M6905 5019 c-38 -65 -45 -83 -34 -90 24 -15 47 -10 54 14 4 12 23 48
42 80 19 32 34 60 32 61 -2 2 -13 6 -25 10 -18 5 -28 -5 -69 -75z"
          />
          <path
            d="M6377 4905 c-15 -31 -17 -77 -17 -362 l0 -327 -27 -28 c-23 -24 -27
-38 -28 -86 -1 -50 -7 -67 -53 -144 -29 -49 -57 -88 -62 -88 -4 0 -13 12 -19
28 -10 24 -11 21 -7 -24 4 -41 0 -59 -23 -100 -42 -76 -55 -94 -67 -94 -6 0
-39 29 -74 65 -34 36 -64 65 -65 63 -2 -2 23 -50 56 -108 32 -58 59 -110 59
-116 0 -25 30 -21 77 11 28 19 53 40 56 48 3 8 23 18 44 22 53 10 55 12 37 47
-9 17 -14 39 -11 49 3 10 38 73 79 139 61 99 79 121 106 131 24 8 38 21 49 47
17 42 12 70 -22 110 l-25 30 0 326 c0 284 -2 330 -17 361 -9 19 -20 35 -23 35
-3 0 -14 -16 -23 -35z"
          />
          <path
            d="M5416 4684 c-10 -27 -7 -33 33 -54 22 -11 56 -31 77 -45 45 -31 50
-31 65 -3 10 18 9 24 -6 33 -9 5 -44 27 -77 48 -65 41 -83 45 -92 21z"
          />
          <path
            d="M7326 4678 c-22 -11 -45 -26 -52 -33 -7 -6 -26 -18 -43 -25 -26 -10
-29 -15 -20 -31 14 -27 41 -23 80 11 35 31 34 38 -4 19 -19 -9 -18 -7 3 10 14
11 29 16 34 11 9 -9 66 8 66 20 0 15 -12 40 -19 40 -3 -1 -24 -10 -45 -22z"
          />
          <path
            d="M5278 4242 c-16 -3 -18 -18 -18 -128 l0 -124 30 0 30 0 0 124 c0 128
-3 137 -42 128z"
          />
          <path
            d="M5350 4235 c0 -6 14 -32 30 -58 17 -26 30 -53 30 -60 0 -7 -16 -36
-35 -64 -19 -29 -35 -55 -35 -58 0 -3 14 -5 30 -5 24 0 35 7 51 35 12 19 24
35 28 35 3 0 15 -16 25 -35 16 -29 25 -35 53 -35 l34 0 -26 43 c-49 79 -51 86
-32 118 9 16 25 42 34 58 10 16 15 33 11 37 -15 15 -58 -8 -79 -42 l-22 -37
-21 36 c-14 24 -29 37 -48 39 -17 3 -28 0 -28 -7z"
          />
          <path
            d="M7308 4242 c-16 -3 -18 -18 -18 -128 l0 -124 30 0 30 0 0 124 c0 128
-3 137 -42 128z"
          />
          <path
            d="M7403 4243 c-10 -3 -13 -39 -13 -129 l0 -124 30 0 c30 0 30 1 30 53
0 99 -13 207 -24 206 -6 0 -17 -3 -23 -6z"
          />
          <path
            d="M7490 4120 l0 -130 25 0 25 0 0 124 c0 126 -3 136 -41 136 -5 0 -9
-58 -9 -130z"
          />
          <path
            d="M6398 3945 c-9 -39 -25 -136 -33 -202 l-6 -53 41 0 c47 0 46 -5 25
129 -8 53 -16 110 -17 126 l-4 30 -6 -30z"
          />
          <path
            d="M6582 3798 c-29 -61 -49 -115 -45 -119 5 -4 22 -10 39 -13 l31 -7 18
115 c9 63 15 120 13 126 -1 5 -27 -40 -56 -102z"
          />
          <path
            d="M6763 3706 l-92 -91 32 -22 c17 -13 35 -19 39 -15 11 11 120 214 116
217 -2 1 -44 -39 -95 -89z"
          />
          <path
            d="M5500 3636 c-95 -60 -94 -59 -81 -84 l12 -22 52 31 c29 16 67 38 85
46 34 18 40 31 20 51 -18 18 -29 15 -88 -22z"
          />
          <path
            d="M7213 3651 c-10 -17 -7 -22 27 -45 22 -14 44 -26 48 -26 5 0 26 -11
45 -25 36 -24 37 -24 47 -4 6 10 8 24 5 29 -12 19 -62 39 -83 33 -17 -4 -22
-1 -22 14 0 11 -11 25 -25 31 -32 15 -28 15 -42 -7z m137 -72 l25 -20 -35 17
c-43 20 -47 24 -29 24 8 0 25 -10 39 -21z"
          />
          <path
            d="M5800 3588 c100 -93 162 -148 169 -148 9 0 47 68 41 73 -3 1 -61 29
-130 60 l-125 57 45 -42z"
          />
          <path
            d="M6311 3609 c-107 -21 -219 -109 -270 -213 -17 -36 -35 -85 -39 -108
l-8 -43 -99 -7 c-233 -18 -599 -86 -746 -139 -58 -21 -81 -37 -36 -25 45 12
338 46 527 61 301 23 859 35 1145 25 253 -9 606 -38 790 -65 54 -8 101 -13
103 -11 9 10 -227 73 -288 77 -19 2 -39 6 -45 10 -17 12 -193 38 -365 55 -91
9 -168 18 -172 21 -5 2 -8 15 -8 28 0 30 -29 105 -41 105 -5 0 -4 -12 1 -26 9
-22 8 -25 -9 -19 -12 3 -21 1 -24 -7 -2 -7 -2 -1 0 14 3 18 -2 30 -14 38 -15
10 -15 11 -1 6 13 -4 15 -1 11 11 -5 12 -2 15 10 10 21 -8 21 -4 3 31 -26 50
-147 142 -212 160 -49 14 -107 16 -99 3 3 -5 1 -12 -4 -16 -6 -3 -15 4 -21 15
-11 21 -21 23 -89 9z m359 -127 c0 -3 -5 -1 -12 6 -7 7 -22 12 -34 12 -15 0
-28 10 -37 29 l-15 29 49 -35 c27 -19 49 -38 49 -41z m-92 -9 c2 -9 -7 -13
-27 -13 -30 0 -39 9 -24 24 11 10 46 3 51 -11z m172 -168 c0 -8 -4 -15 -10
-15 -5 0 -7 7 -4 15 4 8 8 15 10 15 2 0 4 -7 4 -15z m-31 -11 c8 -7 -73 -2
-104 6 -19 5 -6 6 35 3 36 -3 67 -7 69 -9z m-159 -44 l0 -50 -37 1 c-37 1 -37
2 -8 8 17 3 30 13 30 21 0 8 -5 14 -12 13 -13 -3 -7 22 10 45 15 19 17 15 17
-38z"
          />
          <path
            d="M6910 3565 c-63 -29 -115 -57 -117 -61 -1 -5 8 -21 20 -36 l23 -28
102 90 c57 50 100 90 95 89 -4 0 -60 -25 -123 -54z"
          />
          <path
            d="M5750 3349 c133 -51 169 -63 174 -58 2 2 6 21 9 41 l5 36 -76 6 c-42
4 -108 9 -147 11 l-70 5 105 -41z"
          />
          <path
            d="M7085 3384 c-11 -2 -64 -6 -117 -9 -98 -7 -98 -7 -98 -33 0 -57 8
-57 151 -3 118 44 135 56 64 45z"
          />
          <path
            d="M8865 2620 c-195 -35 -304 -145 -305 -308 0 -85 56 -165 149 -211 31
-16 119 -45 196 -64 145 -38 184 -57 199 -99 46 -129 -213 -160 -416 -51 -37
20 -69 35 -70 32 -19 -28 -68 -144 -68 -159 0 -23 97 -79 185 -106 91 -28 330
-26 403 3 153 61 231 188 202 327 -25 120 -126 194 -325 235 -129 27 -180 47
-205 78 -26 34 -25 55 5 92 53 62 216 65 353 5 43 -19 66 -24 73 -17 12 12 59
137 59 157 0 16 -72 48 -155 70 -77 19 -216 27 -280 16z"
          />
          <path
            d="M1390 2435 l0 -175 105 0 105 0 0 80 0 80 149 0 149 0 -38 -92 c-21
-51 -97 -223 -169 -383 l-130 -290 37 -8 c20 -4 77 -6 125 -5 l88 3 38 90 c40
94 169 387 216 490 80 176 95 223 95 306 l0 79 -385 0 -385 0 0 -175z"
          />
          <path
            d="M2552 2588 c-12 -24 -205 -456 -262 -588 -18 -41 -43 -97 -55 -125
-12 -27 -39 -87 -60 -133 -20 -46 -34 -86 -32 -89 10 -9 211 -15 223 -6 5 4
28 51 51 103 l40 95 222 0 223 0 42 -100 43 -100 119 3 c65 2 120 4 121 6 2 2
-18 50 -45 107 -27 57 -124 272 -217 477 l-168 372 -117 0 c-111 0 -117 -1
-128 -22z m148 -260 c7 -18 37 -91 67 -161 29 -71 53 -130 53 -133 0 -2 -63
-4 -141 -4 l-140 0 7 23 c3 12 24 63 46 112 22 50 49 116 60 147 12 31 25 55
29 53 3 -3 12 -19 19 -37z"
          />
          <path
            d="M3330 2131 c0 -427 2 -480 16 -485 20 -8 152 -8 181 0 23 6 23 6 25
272 l3 266 130 -217 130 -217 56 0 c66 0 64 -2 144 135 32 55 81 138 109 185
28 46 56 94 61 105 7 14 11 -62 13 -252 l2 -272 46 -7 c53 -8 163 0 173 13 3
4 5 221 3 481 l-3 472 -97 0 -97 0 -115 -192 c-62 -106 -139 -235 -169 -286
-30 -51 -59 -91 -65 -89 -5 2 -86 130 -179 285 l-170 282 -98 0 -99 0 0 -479z"
          />
          <path
            d="M4636 2443 c-9 -200 -5 -778 5 -794 10 -17 530 -6 594 13 136 40 258
135 307 239 72 153 61 370 -26 501 -57 87 -130 140 -246 180 -60 20 -88 22
-346 26 l-281 4 -7 -169z m568 -53 c63 -32 98 -67 127 -127 20 -40 24 -63 24
-138 -1 -80 -4 -96 -27 -136 -36 -61 -75 -98 -128 -123 -39 -18 -65 -20 -190
-21 l-145 0 -3 165 c-2 91 0 221 3 288 l7 124 142 -4 c127 -3 146 -6 190 -28z"
          />
          <path
            d="M6037 2603 c-3 -5 -53 -115 -111 -246 -58 -131 -115 -257 -125 -280
-11 -23 -37 -82 -59 -132 -22 -49 -53 -119 -69 -155 -42 -93 -56 -130 -52
-135 3 -2 50 -7 106 -11 71 -5 107 -3 116 4 8 7 31 55 52 107 l39 95 217 0
c161 0 219 -3 226 -12 5 -7 25 -49 43 -93 18 -44 38 -86 44 -94 9 -11 33 -12
120 -7 61 4 112 9 115 11 2 3 -10 35 -27 72 -91 201 -228 507 -291 648 -39 88
-79 177 -89 197 l-17 38 -117 0 c-64 0 -119 -3 -121 -7z m146 -298 c64 -148
107 -255 107 -264 0 -7 -48 -11 -136 -11 -125 0 -136 1 -132 18 7 24 131 322
133 319 1 -1 14 -29 28 -62z"
          />
          <path
            d="M6640 2515 l0 -95 150 0 150 0 2 -387 3 -388 110 0 110 0 6 385 c3
212 6 386 7 388 1 1 70 2 152 2 l150 0 0 95 0 95 -420 0 -420 0 0 -95z"
          />
          <path
            d="M7760 2423 c-46 -104 -98 -219 -116 -258 -105 -231 -224 -508 -220
-512 2 -3 49 -7 103 -10 103 -6 143 3 143 32 0 8 11 39 25 69 14 30 29 66 35
80 l10 26 218 0 219 0 45 -102 46 -103 118 3 c65 2 120 4 121 6 2 2 -15 43
-38 92 -23 49 -70 152 -104 229 -34 77 -113 251 -175 388 l-113 247 -117 0
-117 0 -83 -187z m270 -215 c34 -84 64 -158 67 -165 4 -10 -25 -13 -137 -13
-131 0 -142 1 -136 18 33 88 131 312 136 312 4 0 36 -68 70 -152z"
          />
          <path
            d="M9480 2297 c0 -348 5 -389 63 -486 39 -65 127 -134 200 -157 73 -22
201 -29 283 -15 160 28 278 138 314 293 5 24 10 186 10 361 l0 317 -109 0
-108 0 -7 -37 c-3 -21 -6 -162 -6 -314 l0 -275 -27 -55 c-33 -63 -77 -90 -159
-97 -91 -8 -157 27 -197 101 -21 40 -22 54 -25 360 l-3 317 -115 0 -114 0 0
-313z"
          />
          <path
            d="M10557 2603 c-4 -3 -7 -219 -7 -479 l0 -472 23 -6 c37 -10 528 -7
597 4 36 6 97 26 137 46 68 33 74 38 104 99 28 58 31 72 27 127 -7 88 -40 152
-100 196 l-49 35 34 36 c52 54 67 91 67 163 -1 133 -76 215 -228 247 -57 12
-594 16 -605 4z m536 -182 c68 -26 89 -104 43 -158 l-24 -28 -166 -3 -166 -3
0 100 0 101 144 0 c80 0 156 -4 169 -9z m45 -385 c59 -30 81 -84 58 -139 -24
-57 -59 -67 -250 -67 l-166 0 0 110 0 110 165 0 c123 0 173 -4 193 -14z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
